<script>
    export let show;    
</script>

<li><span class="strong">"{show.name}"</span> {show.description} ({show.date}), {show.location}.</li>

